/* eslint-disable react-native/no-inline-styles */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { Peer } from '../types/dyte-client';
import { defaultIconPack, IconPack } from '../lib/icons';
import { DyteParticipant } from '@dytesdk/web-core';
import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function ({
  participant,
  iconPack = defaultIconPack,
  isScreenshare = false,
  size = 'sm',
  variant = 'bar',
}: {
  participant: Peer | DyteParticipant;
  iconPack?: IconPack;
  isScreenshare?: boolean;
  size?: 'lg' | 'md' | 'sm' | 'xl';
  variant?: 'bar';
}) {
  const { storeStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  iconPack = iconPack ?? defaultIconPack;
  const [h1, setHeight1] = useState(10);
  const [h2, setHeight2] = useState(10);
  const [h3, setHeight3] = useState(10);

  const styles = StyleSheet.create({
    visualBar: {
      width: 4,
      backgroundColor: colors.brand[300],
      marginHorizontal: 2,
      borderRadius: 8,
      height: 10,
    },
    container: {
      flexDirection: 'row',
      paddingVertical: 8,
      paddingHorizontal: 4,
      backgroundColor: colors.background[800],
      borderRadius: 4,
    },
  });
  return (
    <View style={styles.container}>
      <View style={{ ...styles.visualBar, height: 10 }} />
      <View style={{ ...styles.visualBar, height: 10 }} />
      <View style={{ ...styles.visualBar, height: 10 }} />
    </View>
  );
}
